var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions,"placeholder":_vm.$t('common.default_search_key', [_vm.$t('compute.text_228')])}})
}
var staticRenderFns = []

export { render, staticRenderFns }